const navMapping = {
  '/': {
    navKey: 'workflows',
  },
};

export default navMapping;
